import { motion, useScroll } from "framer-motion";

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  return (
    <motion.div
      data-testid="scroll-progress"
      className="fixed top-0 left-0 right-0 h-[3px] bg-[#C4963B] z-[60] origin-left"
      style={{ scaleX: scrollYProgress }}
    />
  );
}
